document.addEventListener('DOMContentLoaded', () => {



  document.querySelectorAll('[data-ir-order-made]').forEach((root) => {



    initIrOrderMadeForm(root);



  });



});



function initIrOrderMadeForm(root) {



  /* =========================================================



     PRODUCT DATA



  ========================================================= */



  const productJsonEl = root.querySelector('[data-ir-om-product-json]');



  if (!productJsonEl) {



    console.error('[IR Order Made] 商品JSONが見つかりません。');



    return;



  }



  let product;



  try {



    product = JSON.parse(productJsonEl.textContent);



  } catch (error) {



    console.error(



      '[IR Order Made] 商品データを読み込めませんでした。',



      error



    );



    return;



  }



  /* =========================================================



     PRODUCT FORM



  ========================================================= */



  const formId = root.dataset.productFormId;



  const productForm = document.getElementById(formId);



  if (!productForm) {



    console.error(



      '[IR Order Made] 商品フォームが見つかりません:',



      formId



    );



    return;



  }



  /* =========================================================



     DAWN VARIANT SELECTS



  ========================================================= */



  const sectionId = getSectionId();



  // テーマエディターや遅延描画に対応するため、操作のたびに探す。



  function findDawnVariantPicker() {



    const section = root.closest('product-info') || root.closest('.shopify-section');



    const selectors = [



      `[id="variant-selects-${sectionId}"]`,



      'variant-selects',



      'variant-radios'



    ];



    for (const selector of selectors) {



      const picker = (section && section.querySelector(selector)) || document.querySelector(selector);



      if (picker && picker.querySelectorAll('.product-form__input').length >= 3) return picker;



    }



    return null;



  }



  /* =========================================================



     ELEMENTS



  ========================================================= */



  /* 01 / SIZE */



  const sizeButtons =



    root.querySelectorAll('[data-ir-om-size]');



  const sizeProperty =



    root.querySelector('[data-ir-om-size-property]');



  /* 02 / TWEED */



  const tweedButtons =



    root.querySelectorAll('[data-ir-om-tweed]');



  const tweedProperty =



    root.querySelector('[data-ir-om-tweed-property]');



  /* 03 / COLOR */



  const colorButtons =



    root.querySelectorAll('[data-ir-om-color]');



  const colorProperty =



    root.querySelector('[data-ir-om-color-property]');



  const selectedColorsBox =



    root.querySelector('[data-ir-om-selected-colors]');



  const selectedNames =



    root.querySelector('[data-ir-om-selected-names]');



  const selectedRoses =



    root.querySelector('[data-ir-om-selected-roses]');



  /* 04 / COLOR RATIO */



  const ratioSection =



    root.querySelector('[data-ir-om-ratio-section]');



  const ratioButtons =



    root.querySelectorAll('[data-ir-om-ratio]');



  const ratioMajor =



    root.querySelector('[data-ir-om-ratio-major]');



  const majorOptions =



    root.querySelector('[data-ir-om-major-options]');



  const ratioResult =



    root.querySelector('[data-ir-om-ratio-result]');



  const ratioResultContent =



    root.querySelector('[data-ir-om-ratio-result-content]');



  const countArea =



    root.querySelector('[data-ir-om-count-area]');



  const countList =



    root.querySelector('[data-ir-om-count-list]');



  const countTotal =



    root.querySelector('[data-ir-om-count-total]');



  const ratioProperty =



    root.querySelector('[data-ir-om-ratio-property]');



  const majorProperty =



    root.querySelector('[data-ir-om-major-property]');



  const countProperty =



    root.querySelector('[data-ir-om-count-property]');



  /* 05 / DECORATION */



  const decorationToggleButtons =



    root.querySelectorAll('[data-ir-om-decoration-toggle]');



  const decorationOptions =



    root.querySelector('[data-ir-om-decoration-options]');



  const decorationButtons =



    root.querySelectorAll('[data-ir-om-decoration]');

    
/* 30・33本：人気の装飾は価格の直前に表示 */

const is3033Form = Array.from(
  root.querySelectorAll('[data-ir-om-size]')
).some(button => {
  const size = (button.dataset.irOmSize || '').match(/\d+/)?.[0];
  return size === '30' || size === '33';
});

if (is3033Form) {
  decorationButtons.forEach(button => {
    const label = button.dataset.decorationLabel || '';

    const isPopular =
      label.includes('クリスタル18粒') ||
      (
        label.includes('クリスタル9粒') &&
        label.includes('パール3粒')
      );

    if (!isPopular) return;

    // 既存の価格表示の直前に文字を追加
    const price = button.querySelector('strong');

    if (!price || button.querySelector('.ir-om-popular-text')) return;

    const popular = document.createElement('span');
    popular.className = 'ir-om-popular-text';
    popular.textContent = 'おすすめ♡';

    price.prepend(popular);
  });
}


  const decorationProperty =



    root.querySelector('[data-ir-om-decoration-property]');


    
/* =========================================================
   05 / DECORATION GUIDE
   クリスタル・パールの素材説明（開閉メニュー）
========================================================= */

if (!root.querySelector('[data-ir-om-decoration-guide]')) {
  const decorationAnchor =
    root.querySelector('[data-ir-om-decoration-options]');

  if (decorationAnchor) {
    const guide = document.createElement('details');

    guide.className = 'ir-om-decoration-guide';
    guide.setAttribute('data-ir-om-decoration-guide', '');

    guide.innerHTML = `
      <summary class="ir-om-decoration-guide__summary">
        <span>クリスタル・パールの装飾について</span>
        <span class="ir-om-decoration-guide__plus" aria-hidden="true"></span>
      </summary>

      <div class="ir-om-decoration-guide__body">

        <div class="ir-om-decoration-guide__item">
          <img
            src="https://cdn.shopify.com/s/files/1/0653/3280/5813/files/IRiller-crystal.webp?v=1791472084"
            alt="IRiller（アイリエ）のクリスタル装飾"
            loading="lazy"
            width="800"
            height="800"
          >

          <p class="ir-om-decoration-guide__title">
            CRYSTAL｜クリスタル
          </p>

          <p>
            1輪につき3粒のクリスタルを使用し、グリッターローズに華やかな輝きを添えます。
          </p>

          <p>
            スワロフスキー®・クリスタル、またはPreciosa（プレシオサ）のChaton MAXIMAを使用しています。
          </p>

          <p class="ir-om-decoration-guide__note">
            ※使用するクリスタルは商品によって異なります。種類のご指定はいただけませんが、どちらも美しい輝きをお楽しみいただけます。
          </p>
        </div>

        <div class="ir-om-decoration-guide__item">
          <img
            src="https://cdn.shopify.com/s/files/1/0653/3280/5813/files/IRiller-pearl.jpg?v=1791472961"
            alt="IRiller（アイリエ）のパール装飾"
            loading="lazy"
            width="800"
            height="800"
          >

          <p class="ir-om-decoration-guide__title">
            PEARL｜パール
          </p>

          <p>
            1輪につき1粒のパールを使用します。上品でやわらかな光沢が、グリッターローズの美しさを引き立てます。
          </p>
        </div>

      </div>
    `;

    decorationAnchor.insertAdjacentElement('afterend', guide);
  }
}

/* 装飾ガイド専用CSS */
if (!document.getElementById('ir-om-decoration-guide-css')) {
  const style = document.createElement('style');
  style.id = 'ir-om-decoration-guide-css';

  style.textContent = `
    .ir-om-decoration-guide {
      margin-top: 16px;
      border: 1px solid #ded4ce;
      background: #fff;
    }

    .ir-om-decoration-guide__summary {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 14px 16px;
      cursor: pointer;
      color: #5b4038;
      font-size: 12px;
      font-weight: 600;
      line-height: 1.6;
      list-style: none;
    }

    .ir-om-decoration-guide__summary::-webkit-details-marker {
      display: none;
    }

    .ir-om-decoration-guide__plus {
      position: relative;
      flex: 0 0 14px;
      width: 14px;
      height: 14px;
    }

    .ir-om-decoration-guide__plus::before,
    .ir-om-decoration-guide__plus::after {
      content: "";
      position: absolute;
      background: #8a746c;
    }

    .ir-om-decoration-guide__plus::before {
      width: 12px;
      height: 1px;
      top: 7px;
      left: 1px;
    }

    .ir-om-decoration-guide__plus::after {
      width: 1px;
      height: 12px;
      top: 1px;
      left: 7px;
    }

    .ir-om-decoration-guide[open]
    .ir-om-decoration-guide__plus::after {
      display: none;
    }

    .ir-om-decoration-guide__body {
      padding: 16px;
      border-top: 1px solid #eee6e1;
    }

    .ir-om-decoration-guide__item + .ir-om-decoration-guide__item {
      margin-top: 22px;
      padding-top: 22px;
      border-top: 1px solid #eee6e1;
    }

    .ir-om-decoration-guide__item img {
      display: block;
      width: 100%;
      max-width: 420px;
      height: auto;
      margin: 0 auto 13px;
      object-fit: contain;
    }

    .ir-om-decoration-guide__title {
      margin: 0 0 9px;
      color: #5b4038;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: .06em;
    }

    .ir-om-decoration-guide__item p:not(.ir-om-decoration-guide__title) {
      margin: 0 0 9px;
      color: #6e5951;
      font-size: 11px;
      line-height: 1.9;
    }

    .ir-om-decoration-guide__item
    .ir-om-decoration-guide__note {
      color: #8a746c;
      font-size: 10px;
    }

    @media (max-width: 749px) {
      .ir-om-decoration-guide__summary {
        padding: 12px 13px;
        font-size: 11px;
      }

      .ir-om-decoration-guide__body {
        padding: 13px;
      }

      .ir-om-decoration-guide__item img {
        max-width: 100%;
      }
    }
  `;

  document.head.appendChild(style);
}




  /* 06 / REQUEST */



  const requestTextarea =



    root.querySelector('[data-ir-om-request]');



  /* =========================================================



     STATE



  ========================================================= */



  let selectedSize = '';



  let selectedTweed = '';



  let selectedRank = '';



  let selectedColors = [];



  let selectedRatio = '';



  let selectedMajorColor = '';



  let manualCounts = {};



  let decorationMode = '';



  let selectedDecoration = null;



  /* =========================================================



     COMMON



  ========================================================= */



  function setSingleSelected(buttons, selectedButton) {



    buttons.forEach((button) => {



      const isSelected = button === selectedButton;



      button.classList.toggle(



        'is-selected',



        isSelected



      );



      button.setAttribute(



        'aria-pressed',



        isSelected ? 'true' : 'false'



      );



    });



  }



  function clearSelectedButtons(buttons) {



    buttons.forEach((button) => {



      button.classList.remove('is-selected');



      button.setAttribute('aria-pressed', 'false');



    });



  }



  /* =========================================================



     01 / SIZE



  ========================================================= */



  sizeButtons.forEach((button) => {



    button.addEventListener('click', () => {



      selectedSize =



        button.dataset.irOmSize || '';



      setSingleSelected(



        sizeButtons,



        button



      );



      if (sizeProperty) {



        sizeProperty.value = selectedSize;



      }



      if (selectedRatio === '本数指定') {



        renderManualCountInputs();



      } else if (selectedRatio === '均等') {



        renderEqualRatioResult();



      } else if (selectedRatio === '7：3' && selectedMajorColor) {



        renderSevenThreeResult();



      } else if (selectedRatio === '7：1.5：1.5' && selectedMajorColor) {



        renderThreeColorAccentResult();



      }



      updateVariant();



      // サイズ変更後も、現在選択中のカラー配分に合う制作例へ切り替える。



      if (selectedRatio === '均等' || selectedRatio === '7：3' || selectedRatio === '7：1.5：1.5') {



        showRatioGuide(selectedRatio);



      }



    });



  });



  /* =========================================================



     02 / TWEED



  ========================================================= */



  tweedButtons.forEach((button) => {



    button.addEventListener('click', () => {



      selectedTweed =



        button.dataset.irOmTweed || '';



      selectedRank =



        button.dataset.irOmRank || '';



      setSingleSelected(



        tweedButtons,



        button



      );



      if (tweedProperty) {



        
        tweedProperty.value = selectedTweed;

        // 刺繍カスタマイザーにツイード生地の変更を通知
        tweedProperty.dispatchEvent(
          new Event('change', { bubbles: true })
        );




      }



      updateVariant();



    });



  });



  /* =========================================================



     03 / COLOR



  ========================================================= */



  colorButtons.forEach((button) => {



    button.addEventListener('click', () => {



      const color = {



        number: button.dataset.colorNumber || '',



        name: button.dataset.colorName || '',



        image: button.dataset.colorImage || ''



      };



      const existingIndex =



        selectedColors.findIndex(



          (item) => item.number === color.number



        );



      /* -----------------------------------------------------



         SELECTED → REMOVE



      ----------------------------------------------------- */



      if (existingIndex !== -1) {



        selectedColors.splice(



          existingIndex,



          1



        );



        button.classList.remove(



          'is-selected'



        );



        button.setAttribute(



          'aria-pressed',



          'false'



        );



      }



      /* -----------------------------------------------------



         NOT SELECTED → ADD



      ----------------------------------------------------- */



      else {



        selectedColors.push(color);



        button.classList.add(



          'is-selected'



        );



        button.setAttribute(



          'aria-pressed',



          'true'



        );



      }



      updateColorProperty();



      renderSelectedColors();



      resetRatio();



      updateRatioVisibility();



      updateVariant();



    });



  });



  /* =========================================================



     SELECTED COLORS



  ========================================================= */



  function renderSelectedColors() {



    if (



      !selectedColorsBox ||



      !selectedNames ||



      !selectedRoses



    ) {



      return;



    }



    /* 0 COLORS */



    if (selectedColors.length === 0) {



      selectedColorsBox.hidden = true;



      selectedNames.innerHTML = '';



      selectedRoses.innerHTML = '';



      return;



    }



    selectedColorsBox.hidden = false;



    /* NAMES */



    selectedNames.innerHTML =



      selectedColors



        .map((color) => {



          return `



            <span class="ir-om__selected-name">



              ${getCircledNumber(color.number)}



              ${escapeHtml(color.name)}



            </span>



          `;



        })



        .join('');



    /* ROSES */



    selectedRoses.innerHTML =



      selectedColors



        .map((color, index) => {



          return `



            <div



              class="ir-om__selected-rose"



              style="animation-delay:${index * 0.04}s;"



            >



              <img



                src="${escapeHtml(color.image)}"



                alt="${escapeHtml(color.name)}"



              >



            </div>



          `;



        })



        .join('');



  }



  /* =========================================================



     COLOR PROPERTY



  ========================================================= */



  function updateColorProperty() {



    if (!colorProperty) return;



    colorProperty.value =



      selectedColors



        .map((color) => {



          return (



            `${getCircledNumber(color.number)}` +



            `${color.name}`



          );



        })



        .join(' / ');



  }



  /* =========================================================



     COLOR TYPE



  ========================================================= */



  function getSelectedColorType() {



    if (selectedColors.length === 0) {



      return '';



    }



    if (selectedColors.length === 1) {



      return '単色';



    }



    return '複数色';



  }



  /* =========================================================



     04 / RATIO VISIBILITY



  ========================================================= */



  function updateRatioVisibility() {



    if (!ratioSection) return;



    if (selectedColors.length <= 1) {



      ratioSection.hidden = true;



      return;



    }



    ratioSection.hidden = false;



    ratioButtons.forEach((button) => {



      const ratio = button.dataset.irOmRatio || '';



      if (ratio === '7：3') {



        button.hidden = false;



        if (selectedColors.length === 3) {



          // 既存の7:3ボタンを3色用おすすめ配分として利用する。



          if (!button.dataset.irOmOriginalHtml) button.dataset.irOmOriginalHtml = button.innerHTML;



          button.innerHTML = '7：1.5：1.5<br><small>おすすめ</small>';



          button.setAttribute('aria-label', '3色のおすすめ比率 7：1.5：1.5');



        } else if (selectedColors.length === 2) {



          if (button.dataset.irOmOriginalHtml) button.innerHTML = button.dataset.irOmOriginalHtml;



          button.removeAttribute('aria-label');



        } else {



          button.hidden = true;



        }



      } else {



        button.hidden = false;



      }



    });



  }











    /* =========================================================



     04 / RATIO BUTTONS



  ========================================================= */



  ratioButtons.forEach((button) => {



    button.addEventListener('click', () => {



      selectedRatio =



        button.dataset.irOmRatio || '';



      if (selectedRatio === '7：3' && selectedColors.length === 3) {



        selectedRatio = '7：1.5：1.5';



      }



      setSingleSelected(



        ratioButtons,



        button



      );



      clearRatioSubViews();



      /* 7:3 */



      if (selectedRatio === '7：3' || selectedRatio === '7：1.5：1.5') {



        if (ratioProperty) {



          ratioProperty.value = selectedRatio;



        }



        showRatioGuide(selectedRatio);



        renderMajorColorOptions();



        return;



      }



      /* EQUAL */



      if (selectedRatio === '均等') {



        if (ratioProperty) {



          ratioProperty.value = '均等';



        }



        if (majorProperty) {



          majorProperty.value = '';



        }



        if (countProperty) {



          countProperty.value = '';



        }



        showRatioGuide('均等');



        renderEqualRatioResult();



        return;



      }



      /* MANUAL */



      if (selectedRatio === '本数指定') {



        if (ratioProperty) {



          ratioProperty.value = '本数指定';



        }



        if (majorProperty) {



          majorProperty.value = '';



        }



        renderManualCountInputs();



      }



    });



  });



  /* =========================================================



     RATIO GUIDE



     Variant連動部分には触れず、04の制作例だけを表示。



  ========================================================= */



  function removeRatioGuide() {



    const guide = root.querySelector('[data-ir-om-ratio-guide]');



    if (guide) guide.remove();



  }



    function showRatioGuide(type) {

    removeRatioGuide();

    const ratioOptions = root.querySelector('.ir-om__ratio-options');

    if (!ratioOptions) return;

    let imageUrl = '';
    let title = '';
    let description = '';
    let notes = '';

    const sizeCount = getSelectedSizeCount();

    if (type === '7：3') {

      imageUrl = sizeCount === 50
        ? 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-50-color-ratio-7-3.jpg?v=1791517743'
        : 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-bouquet-ordermade-production-example13.jpg?v=1782226595';

      title = '洗練された7：3のバランス';

      description = 'メインカラーの存在感を引き立てながら、アクセントカラーが華やかさを添える配分。';

      notes = `
        <p>※画像はイメージです。実際に選択された色を示すものではありません。</p>
        <p>※一点一点手作業でお作りしているため、実際の配置は多少異なる場合がございます。</p>
        ${sizeCount === 50
          ? '<p>※画像の商品には、パール6粒（6輪分）の装飾を施しています。</p>'
          : '<p>※画像の商品には、パール3粒（3輪分）・クリスタル9粒（3輪分）の装飾を施しています。</p><p>※画像のロイヤルラッピングボックスは別途ご購入が必要です。</p>'}
      `;

    } else if (type === '7：1.5：1.5') {

      if (sizeCount === 50) {

        imageUrl = 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-50-color-ratio-7-1-5-1-5.jpg?v=1791517820';

      } else if (sizeCount === 30 || sizeCount === 33) {

        imageUrl = 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-30-color-ratio-7-1-5-1-5.jpg?v=1791517674';

      } else {

        imageUrl = 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-30-color-ratio-7-1-5-1-5.jpg?v=1791517674';

      }

      title = '3色の彩りが際立つアクセントバランス';

      description = 'メインカラーを中心に、2色のアクセントを添えた華やかな配分。';

      notes = `
        <p>※画像は配分イメージです。実際に選択された3色を示すものではありません。</p>
        <p>※一点一点手作業でお作りしているため、実際の配置は多少異なる場合がございます。</p>
        ${sizeCount === 50
          ? '<p>※画像の商品には、クリスタル18粒（6輪分）+パール6粒（6輪分）の装飾を施しています。</p><p>※画像のロイヤルラッピングボックスは別途ご購入が必要です。</p>'
          : '<p>※画像のロイヤルラッピングボックスは別途ご購入が必要です。</p>'}
      `;

    } else if (type === '均等') {

      if (sizeCount === 50) {

        imageUrl = selectedColors.length === 3
          ? 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-50-color-ratio-7-1-5-1-5-2.jpg?v=1791628113'
          : 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-50-color-ratio-equal.jpg?v=1791517790';

      } else if (selectedColors.length === 3 && (sizeCount === 30 || sizeCount === 33)) {

      // 30・33本：3色の均等バランス
      imageUrl = 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-30-color-ratio-equal-2.jpg?v=1791517619';

      } else if (selectedColors.length === 2 && (sizeCount === 30 || sizeCount === 33)) {

      // 30・33本：2色の均等バランス
      imageUrl = 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-bouquet-ordermade-production-example11.jpg?v=1782225649';

      } else {

  imageUrl = 'https://cdn.shopify.com/s/files/1/0653/3280/5813/files/glitterrose-ordermade-30-color-ratio-equal-2.jpg?v=1791517619';

     }

      title = selectedColors.length === 2
        ? '2色が美しく調和する均等バランス'
        : '3色が美しく調和する均等バランス';

      description = 'それぞれのカラーの魅力を活かし、全体に彩りを広げる配分。';

      notes = `
        <p>※画像はイメージです。実際に選択された色を示すものではありません。</p>
        <p>※一点一点手作業でお作りしているため、実際の配置は多少異なる場合がございます。</p>
        ${sizeCount === 50
          ? '<p>※画像の商品には、クリスタル36粒（12輪分）+パール3粒（6輪分）の装飾を施しています。</p>'
          : '<p>※画像の商品には、クリスタル9粒（3輪分）+パール3粒（6輪分）の装飾を施しています。</p><p>※画像のロイヤルラッピングボックスやメッセージカードは別途ご購入が必要です。</p>'}
      `;

    } else {

      return;

    }

    const guide = document.createElement('div');

    guide.className = 'ir-om__ratio-guide';

    guide.setAttribute('data-ir-om-ratio-guide', '');

    guide.innerHTML = `
      <img class="ir-om__ratio-guide-image" src="${imageUrl}" alt="${escapeHtml(title)}" loading="lazy">
      <div class="ir-om__ratio-guide-body">
        <p class="ir-om__ratio-guide-title">${escapeHtml(title)}</p>
        <p class="ir-om__ratio-guide-description">${escapeHtml(description)}</p>
        <div class="ir-om__ratio-guide-notes">${notes}</div>
      </div>
    `;

    (ratioResult || ratioMajor || ratioOptions).insertAdjacentElement('afterend', guide);

    ensureRatioGuideStyles();

  }



  function ensureRatioGuideStyles() {



    if (document.getElementById('ir-om-ratio-guide-styles')) return;



    const style = document.createElement('style');



    style.id = 'ir-om-ratio-guide-styles';



    style.textContent = `



      .ir-om__ratio-guide { margin-top:14px; overflow:hidden; background:#fff; border:1px solid #ded4ce; }



      .ir-om__ratio-guide-image { display:block; width:100%; height:auto; }



      .ir-om__ratio-guide-body { padding:12px 13px 13px; }



      .ir-om__ratio-guide-title { margin:0 0 7px; font-size:11px; line-height:1.6; font-weight:600; color:#4e342e; }



      .ir-om__ratio-guide-description { margin:0; font-size:10px; line-height:1.8; color:#5f4a43; }



      .ir-om__ratio-guide-notes { margin-top:9px; padding-top:9px; border-top:1px solid #eee6e1; }



      .ir-om__ratio-guide-notes p { margin:0 0 3px; font-size:9px; line-height:1.65; color:#8a746c; }



      .ir-om__ratio-guide-notes p:last-child { margin-bottom:0; }



    `;



    document.head.appendChild(style);



  }



  /* =========================================================



     RESET RATIO



  ========================================================= */



  function resetRatio() {



    selectedRatio = '';



    selectedMajorColor = '';



    manualCounts = {};



    clearSelectedButtons(



      ratioButtons



    );



    if (ratioProperty) {



      ratioProperty.value = '';



    }



    if (majorProperty) {



      majorProperty.value = '';



    }



    if (countProperty) {



      countProperty.value = '';



    }



    clearRatioSubViews();



  }



  /* =========================================================



     CLEAR RATIO SUB VIEWS



  ========================================================= */



  function clearRatioSubViews() {



    selectedMajorColor = '';



    manualCounts = {};



    removeRatioGuide();



    if (ratioMajor) {



      ratioMajor.hidden = true;



    }



    if (majorOptions) {



      majorOptions.innerHTML = '';



    }



    if (ratioResult) {



      ratioResult.hidden = true;



    }



    if (ratioResultContent) {



      ratioResultContent.innerHTML = '';



    }



    if (countArea) {



      countArea.hidden = true;



    }



    if (countList) {



      countList.innerHTML = '';



    }



    if (countTotal) {



      countTotal.innerHTML = '';



      countTotal.classList.remove(



        'is-valid',



        'is-invalid'



      );



    }



    if (majorProperty) {



      majorProperty.value = '';



    }



    if (countProperty) {



      countProperty.value = '';



    }



  }



  /* =========================================================



     7:3 / MAJOR COLOR



  ========================================================= */



  function renderMajorColorOptions() {



    if (



      (selectedRatio === '7：1.5：1.5' ? selectedColors.length !== 3 : selectedColors.length !== 2) ||



      !ratioMajor ||



      !majorOptions



    ) {



      return;



    }



    ratioMajor.hidden = false;



    const majorTitle = ratioMajor.querySelector('.ir-om__sub-title');



    if (majorTitle) {



      majorTitle.textContent = selectedRatio === '7：1.5：1.5'



        ? 'どのカラーを多くしますか？'



        : 'どちらのカラーを多くしますか？';



    }



    majorOptions.innerHTML =



      selectedColors



        .map((color) => {



          return `



            <button



              type="button"



              class="ir-om__major-option"



              data-ir-om-major-color="${escapeHtml(color.number)}"



              aria-pressed="false"



            >



              <img



                src="${escapeHtml(color.image)}"



                alt=""



              >



              <span>



                ${getCircledNumber(color.number)}



                ${escapeHtml(color.name)}



              </span>



            </button>



          `;



        })



        .join('');



    const majorButtons =



      majorOptions.querySelectorAll(



        '[data-ir-om-major-color]'



      );



    majorButtons.forEach((button) => {



      button.addEventListener('click', () => {



        const number =



          button.dataset.irOmMajorColor || '';



        const color =



          selectedColors.find(



            (item) => item.number === number



          );



        if (!color) return;



        selectedMajorColor =



          color.number;



        setSingleSelected(



          majorButtons,



          button



        );



        if (majorProperty) {



          majorProperty.value =



            `${getCircledNumber(color.number)}` +



            `${color.name}`;



        }



        if (selectedRatio === '7：1.5：1.5') {



          renderThreeColorAccentResult();



        } else {



          renderSevenThreeResult();



        }



      });



    });



  }



  /* =========================================================



     7:3 RESULT



  ========================================================= */



  function renderSevenThreeResult() {



    if (



      selectedColors.length !== 2 ||



      !selectedMajorColor ||



      !ratioResult ||



      !ratioResultContent



    ) return;







    const majorColor = selectedColors.find(color => color.number === selectedMajorColor);



    const minorColor = selectedColors.find(color => color.number !== selectedMajorColor);



    if (!majorColor || !minorColor) return;







    const total = getSelectedSizeCount();



        const majorCount =
      total === 33 ? 24 :
      total === 50 ? 36 :
      (total ? Math.round(total * 0.7) : 0);



    const minorCount = total - majorCount;



    const allocations = [[majorColor, majorCount], [minorColor, minorCount]];







    ratioResult.hidden = false;



    ratioResultContent.innerHTML = allocations.map(([color, count], index) =>



      createRatioResultRow(



        color,



        total ? `${count}本（${(count / total * 100).toFixed(1)}%）` : (index === 0 ? '70%' : '30%')



      )



    ).join('');







    if (countProperty) {



      countProperty.value = total



        ? allocations.map(([color, count]) => `${getCircledNumber(color.number)}${color.name} ${count}本`).join(' / ')



        : '';



    }



  }



  /* =========================================================



     3 COLORS / 7:1.5:1.5 RESULT



  ========================================================= */



  function renderThreeColorAccentResult() {



    if (selectedColors.length !== 3 || !selectedMajorColor || !ratioResult || !ratioResultContent) return;



    const total = getSelectedSizeCount();



    const major = selectedColors.find(color => color.number === selectedMajorColor);



    const others = selectedColors.filter(color => color.number !== selectedMajorColor);



    if (!major || others.length !== 2) return;



    // 33本の3色配分は、仕上がり重視で24本・5本・4本に調整。



        const mainCount =
      total === 33 ? 24 :
      total === 50 ? 36 :
      (total ? Math.round(total * 0.7) : 0);



    const remaining = total - mainCount;



    const minorA = Math.ceil(remaining / 2);



    const minorB = Math.floor(remaining / 2);



    const allocations = [[major, mainCount], [others[0], minorA], [others[1], minorB]];



    ratioResult.hidden = false;



    ratioResultContent.innerHTML = allocations.map(([color, count]) =>



      createRatioResultRow(color, total ? `${count}本（${(count / total * 100).toFixed(1)}%）` : (color === major ? '70%' : '15%'))



    ).join('') + '<p class="ir-om__ratio-note" style="margin:10px 0 0;font-size:11px;line-height:1.8;color:#8a746c;">※表示の比率は目安です。実際の本数は、花束のサイズに合わせて調整しています。</p>';



    if (countProperty && total) countProperty.value = allocations.map(([color, count]) =>



      `${getCircledNumber(color.number)}${color.name} ${count}本`).join(' / ');



  }







  /* =========================================================



     EQUAL RESULT



  ========================================================= */



  function renderEqualRatioResult() {



    if (selectedColors.length < 2 || !ratioResult || !ratioResultContent) return;



    ratioResult.hidden = false;



    const total = getSelectedSizeCount();



    if (total) {



      // 端数は選択順①から配分。33本・2色なら17本＋16本。



      const base = Math.floor(total / selectedColors.length);



      const remainder = total % selectedColors.length;



      const allocations = selectedColors.map((color, index) => [color, base + (index < remainder ? 1 : 0)]);



      ratioResultContent.innerHTML = allocations.map(([color, count]) =>



        createRatioResultRow(color, `${count}本（${(count / total * 100).toFixed(1)}%）`)



      ).join('');



      if (countProperty) countProperty.value = allocations.map(([color, count]) =>



        `${getCircledNumber(color.number)}${color.name} ${count}本`).join(' / ');



    } else {



      ratioResultContent.innerHTML = selectedColors.map(color =>



        createRatioResultRow(color, `${(100 / selectedColors.length).toFixed(1)}%`)



      ).join('');



    }



  }







    /* =========================================================



     RATIO RESULT ROW



  ========================================================= */



  function createRatioResultRow(



    color,



    percentage



  ) {



    return `



      <div class="ir-om__ratio-result-row">



        <img



          src="${escapeHtml(color.image)}"



          alt=""



        >



        <span class="ir-om__ratio-result-name">



          ${getCircledNumber(color.number)}



          ${escapeHtml(color.name)}



        </span>



        <strong class="ir-om__ratio-result-percent">



          ${escapeHtml(percentage)}



        </strong>



      </div>



    `;



  }



  /* =========================================================



     MANUAL COUNT



  ========================================================= */



  function renderManualCountInputs() {



    if (



      selectedColors.length < 2 ||



      !countArea ||



      !countList



    ) {



      return;



    }



    countArea.hidden = false;



    manualCounts = {};



    countList.innerHTML =



      selectedColors



        .map((color) => {



          return `



            <div class="ir-om__count-row">



              <img



                src="${escapeHtml(color.image)}"



                alt=""



              >



              <span class="ir-om__count-name">



                ${getCircledNumber(color.number)}



                ${escapeHtml(color.name)}



              </span>



              <input



                type="number"



                class="ir-om__count-input"



                min="0"



                step="1"



                inputmode="numeric"



                value=""



                data-ir-om-count-input="${escapeHtml(color.number)}"



                aria-label="${escapeHtml(color.name)}の本数"



              >



              <span class="ir-om__count-unit">



                本



              </span>



            </div>



          `;



        })



        .join('');



    const countInputs =



      countList.querySelectorAll(



        '[data-ir-om-count-input]'



      );



    countInputs.forEach((input) => {



      input.addEventListener(



        'input',



        () => {



          const number =



            input.dataset.irOmCountInput || '';



          const value =



            Math.max(



              0,



              parseInt(input.value, 10) || 0



            );



          manualCounts[number] =



            value;



          updateManualCountTotal();



        }



      );



    });



    updateManualCountTotal();



  }



  /* =========================================================



     MANUAL COUNT TOTAL



  ========================================================= */



  function updateManualCountTotal() {



    if (!countTotal) return;



    const targetCount =



      getSelectedSizeCount();



    const total =



      selectedColors.reduce(



        (sum, color) => {



          return (



            sum +



            (manualCounts[color.number] || 0)



          );



        },



        0



      );



    /* SIZE NOT SELECTED */



    if (!targetCount) {



      countTotal.textContent =



        `合計 ${total}本 / サイズを先に選択してください`;



      countTotal.classList.remove(



        'is-valid',



        'is-invalid'



      );



      updateManualCountProperty();



      return;



    }



    /* VALID */



    if (total === targetCount) {



      countTotal.textContent =



        `合計 ${total} / ${targetCount}本 ✓`;



      countTotal.classList.add(



        'is-valid'



      );



      countTotal.classList.remove(



        'is-invalid'



      );



    }



    /* INVALID */



    else {



      countTotal.textContent =



        `合計 ${total} / ${targetCount}本`;



      countTotal.classList.add(



        'is-invalid'



      );



      countTotal.classList.remove(



        'is-valid'



      );



    }



    updateManualCountProperty();



  }



  /* =========================================================



     MANUAL COUNT PROPERTY



  ========================================================= */



  function updateManualCountProperty() {



    if (!countProperty) return;



    countProperty.value =



      selectedColors



        .map((color) => {



          const count =



            manualCounts[color.number] || 0;



          return (



            `${getCircledNumber(color.number)}` +



            `${color.name} ${count}本`



          );



        })



        .join(' / ');



  }



  /* =========================================================



     SIZE → NUMBER



  ========================================================= */



  function getSelectedSizeCount() {



    if (!selectedSize) {



      return 0;



    }



    const match =



      selectedSize.match(/\d+/);



    if (!match) {



      return 0;



    }



    return Number(match[0]) || 0;



  }



  /* =========================================================



     05 / DECORATION TOGGLE



  ========================================================= */



  decorationToggleButtons.forEach(



    (button) => {



      button.addEventListener(



        'click',



        () => {



          decorationMode =



            button.dataset



              .irOmDecorationToggle || '';



          setSingleSelected(



            decorationToggleButtons,



            button



          );



          /* NONE */



          if (



            decorationMode === 'none'



          ) {



            selectedDecoration = null;



            if (decorationOptions) {



              decorationOptions.hidden = true;



            }



            clearSelectedButtons(



              decorationButtons



            );



            if (decorationProperty) {



              decorationProperty.value =



                '装飾なし';



            }



            return;



          }



          /* YES */



          if (



            decorationMode === 'yes'



          ) {



            if (decorationOptions) {



              decorationOptions.hidden = false;



            }



            if (decorationProperty) {



              decorationProperty.value = '';



            }



          }



        }



      );



    }



  );



  /* =========================================================



     05 / DECORATION ITEM



  ========================================================= */



  decorationButtons.forEach(



    (button) => {



      button.addEventListener(



        'click',



        () => {



          setSingleSelected(



            decorationButtons,



            button



          );



          const type =



            button.dataset.decorationType || '';



          const label =



            button.dataset.decorationLabel || '';



          /* MIXED */



          if (type === 'mixed') {



            selectedDecoration = {



              type: 'mixed',



              label: label,



              items: [



                {



                  variantId:



                    button.dataset



                      .crystalVariantId || '',



                  quantity:



                    Number(



                      button.dataset



                        .crystalQuantity || 1



                    )



                },



                {



                  variantId:



                    button.dataset



                      .pearlVariantId || '',



                  quantity:



                    Number(



                      button.dataset



                        .pearlQuantity || 1



                    )



                }



              ]



            };



          }



          /* SINGLE */



          else {



            selectedDecoration = {



              type: type,



              label: label,



              items: [



                {



                  variantId:



                    button.dataset



                      .decorationVariantId || '',



                  quantity:



                    Number(



                      button.dataset



                        .decorationQuantity || 1



                    )



                }



              ]



            };



          }



          if (decorationProperty) {



            decorationProperty.value =



              label;



          }



          console.log(



            '[IR Order Made] 装飾:',



            selectedDecoration



          );



        }



      );



    }



  );



  /* =========================================================



     06 / REQUEST AUTO RESIZE



  ========================================================= */



  if (requestTextarea) {



    const resizeTextarea = () => {



      requestTextarea.style.height =



        'auto';



      requestTextarea.style.height =



        `${requestTextarea.scrollHeight}px`;



    };



    resizeTextarea();



    requestTextarea.addEventListener(



      'input',



      resizeTextarea



    );



  }



  /* =========================================================



     VARIANT UPDATE



  ========================================================= */



  function updateVariant() {



    /*



      3条件が揃ってから



      Shopify標準Variant Pickerへ同期する。



      1. サイズ



      2. ツイードランク



      3. 単色 / 複数色



    */



    if (!selectedSize) {



      return;



    }



    const selectedColorType = selectedColors.length > 0 ? getSelectedColorType() : '単色';



    const effectiveRank = selectedRank || 'LUXURY';



    /* -----------------------------------------------------



       PRODUCT JSONでもVariantが存在するか確認



    ----------------------------------------------------- */



    const matchedVariant =



      product.variants.find((variant) => {



        return (



          variant.option1 === selectedSize &&



          variant.option2 === effectiveRank &&



          variant.option3 === selectedColorType



        );



      });



    if (!matchedVariant) {



      console.warn(



        '[IR Order Made] 該当Variantがありません:',



        {



          size: selectedSize,



          rank: effectiveRank,



          colorType: selectedColorType



        }



      );



      return;



    }



    /*



      ここではname="id"を直接変更しない。



      Shopify標準Variant Pickerを変更し、



      Dawn自身にVariant更新を任せる。



    */



    syncDawnVariantPicker(



      selectedSize,



      effectiveRank,



      selectedColorType,



      matchedVariant



    );



  }



  /* =========================================================



     DAWN VARIANT PICKER SYNC



  ========================================================= */



  function syncDawnVariantPicker(size, rank, colorType, matchedVariant) {



    const picker = findDawnVariantPicker();



    if (!picker) {



      console.warn('[IR Order Made] 標準ピッカーを取得できません。標準ピッカーを表示して再確認してください。');



      setVariantIdFallback(matchedVariant.id);



      return;



    }



    const desiredValues = [size, rank, colorType];



    const groups = Array.from(picker.querySelectorAll('.product-form__input'));



    const targets = [];



    for (let i = 0; i < desiredValues.length; i++) {



      const group = groups[i];



      const value = desiredValues[i];



      if (!group) return;



      const radios = Array.from(group.querySelectorAll('input[type="radio"]'));



      if (radios.length) {



        const radio = radios.find(input => input.value === value);



        if (!radio) {



          console.warn('[IR Order Made] 標準ピッカーに選択肢がありません:', i + 1, value);



          return;



        }



        targets.push(radio);



      } else {



        const select = group.querySelector('select');



        if (!select || !Array.from(select.options).some(option => option.value === value)) {



          console.warn('[IR Order Made] 標準ピッカーに選択肢がありません:', i + 1, value);



          return;



        }



        targets.push(select);



      }



    }



    // 他の選択肢を先に揃え、最後の1項目だけ実際の操作として発火。



    // Dawnのイベントハンドラが「変更後の全選択値」を読み取れる状態にする。



    const changed = targets.filter((target, i) =>



      target.matches('input[type="radio"]') ? !target.checked : target.value !== desiredValues[i]



    );



    if (changed.length === 0) {



      // 標準UIと同じ選択なら、価格は既に一致している想定。



      console.log('[IR Order Made] 標準ピッカーと同じ選択:', matchedVariant.id);



      return;



    }



    const trigger = changed[changed.length - 1];



    targets.forEach((target, i) => {



      if (target === trigger) return;



      if (target.matches('input[type="radio"]')) target.checked = true;



      else target.value = desiredValues[i];



    });



    if (trigger.matches('input[type="radio"]')) {



      // .click() は checked を変更し、ブラウザーの change イベントを発火する。



      trigger.click();



    } else {



      trigger.value = desiredValues[targets.indexOf(trigger)];



      trigger.dispatchEvent(new Event('change', { bubbles: true }));



    }



    console.log('[IR Order Made] 標準ピッカー操作:', {



      size, rank, colorType, variantId: matchedVariant.id,



      selected: targets.map(target => target.value)



    });



  }



  /* =========================================================



     SYNC FORM VARIANT ID



  ========================================================= */



  function syncFormVariantId(variantId) {



    const idInput =



      productForm.querySelector(



        '[name="id"]'



      );



    if (!idInput) {



      return;



    }



    /*



      Dawnが既に正しいVariantへ



      更新しているなら何もしない。



    */



    if (



      String(idInput.value) ===



      String(variantId)



    ) {



      return;



    }



    /*



      Dawn側が同一UI状態などの理由で



      changeを処理しなかった場合の保険。



    */



    idInput.value =



      String(variantId);



    idInput.dispatchEvent(



      new Event(



        'change',



        {



          bubbles: true



        }



      )



    );



  }



  /* =========================================================



     FALLBACK VARIANT ID



  ========================================================= */



  function setVariantIdFallback(



    variantId



  ) {



    const idInput =



      productForm.querySelector(



        '[name="id"]'



      );



    if (!idInput) {



      console.error(



        '[IR Order Made] name="id" が見つかりません。'



      );



      return;



    }



    const newValue =



      String(variantId);



    if (



      String(idInput.value) ===



      newValue



    ) {



      return;



    }



    idInput.value =



      newValue;



    idInput.dispatchEvent(



      new Event(



        'change',



        {



          bubbles: true



        }



      )



    );



    idInput.dispatchEvent(



      new Event(



        'input',



        {



          bubbles: true



        }



      )



    );



  }



  /* =========================================================



     GET SECTION ID



  ========================================================= */



  function getSectionId() {



    /*



      product-form-SECTION_ID



      ↓



      SECTION_ID



    */



    if (



      formId &&



      formId.indexOf('product-form-') === 0



    ) {



      return formId.replace(



        'product-form-',



        ''



      );



    }



    if (



      variantSelects &&



      variantSelects.dataset.section



    ) {



      return variantSelects.dataset.section;



    }



    return '';



  }



  /* =========================================================



     CIRCLED NUMBER



  ========================================================= */



  function getCircledNumber(number) {



    const numbers = [



      '',



      '①',



      '②',



      '③',



      '④',



      '⑤',



      '⑥',



      '⑦',



      '⑧',



      '⑨',



      '⑩',



      '⑪',



      '⑫',



      '⑬',



      '⑭',



      '⑮',



      '⑯'



    ];



    return (



      numbers[Number(number)] ||



      String(number)



    );



  }



  /* =========================================================



     ESCAPE HTML



  ========================================================= */



  function escapeHtml(value) {



    return String(value)



      .replace(



        /&/g,



        '&amp;'



      )



      .replace(



        /</g,



        '&lt;'



      )



      .replace(



        />/g,



        '&gt;'



      )



      .replace(



        /"/g,



        '&quot;'



      )



      .replace(



        /'/g,



        '&#039;'



      );



  }



  /* =========================================================



     INITIALIZE



  ========================================================= */



  updateRatioVisibility();



}











/* =========================================================



   IRiller ORDER MADE / REQUIRED FIELD VALIDATION



   未入力時はShopifyへの送信を中断（Dawn標準価格連動は変更しない）



   06「その他のご要望」は任意入力



\========================================================= */



document.addEventListener('DOMContentLoaded', () => {



  document.querySelectorAll('[data-ir-order-made]').forEach((root) => {



    const formId = root.dataset.productFormId;



    const form = formId ? document.getElementById(formId) : null;



    if (!form) return;







    const get = (selector) => root.querySelector(selector);



    const selected = (selector) => Array.from(root.querySelectorAll(selector))



      .filter((button) => button.getAttribute('aria-pressed') === 'true' || button.classList.contains('is-selected'));







    function validate() {



      const errors = [];



      const size = selected('[data-ir-om-size]');



      const tweed = selected('[data-ir-om-tweed]');



      const colors = selected('[data-ir-om-color]');



      const decorationMode = selected('[data-ir-om-decoration-toggle]');



      const ratio = (get('[data-ir-om-ratio-property]')?.value || '').trim();



      const major = (get('[data-ir-om-major-property]')?.value || '').trim();







      if (!size.length) errors.push({ section: get('[data-ir-om-size]')?.closest('.ir-om__section'), message: 'サイズを選択してください。' });



      if (!tweed.length) errors.push({ section: get('[data-ir-om-tweed]')?.closest('.ir-om__section'), message: 'ツイード生地を選択してください。' });



      if (!colors.length) errors.push({ section: get('[data-ir-om-color]')?.closest('.ir-om__section'), message: 'グリッターローズの色を選択してください。' });







      if (colors.length >= 2) {



        const ratioSection = get('[data-ir-om-ratio-section]');



        if (!ratio) {



          errors.push({ section: ratioSection, message: 'カラーの割合を選択してください。' });



        } else if ((ratio === '7：3' || ratio === '7：1.5：1.5') && !major) {



          errors.push({ section: ratioSection, message: '多くするカラーを選択してください。' });



        } else if (ratio === '本数指定') {



          const inputs = Array.from(root.querySelectorAll('[data-ir-om-count-input]'));



          const target = Number((size[0]?.dataset.irOmSize || '').match(/\d+/)?.[0] || 0);



          const sum = inputs.reduce((acc, input) => acc + Number(input.value || 0), 0);



          if (!target || inputs.length !== colors.length || inputs.some((input) => input.value.trim() === '' || !Number.isInteger(Number(input.value)) || Number(input.value) < 0) || sum !== target) {



            errors.push({ section: ratioSection, message: `カラー別本数の合計を${target || '選択サイズの'}本に合わせてください。` });



          }



        }



      }







      const decorationSection = get('[data-ir-om-decoration-toggle]')?.closest('.ir-om__section');



      if (!decorationMode.length) {



        errors.push({ section: decorationSection, message: '「装飾なし」または「装飾あり」を選択してください。' });



      } else if (decorationMode[0].dataset.irOmDecorationToggle === 'yes' && !selected('[data-ir-om-decoration]').length) {



        errors.push({ section: decorationSection, message: '花びらの装飾内容を選択してください。' });



      }



      return errors.filter((entry) => entry.section);



    }







    function clearErrors() {



      root.querySelectorAll('[data-ir-om-required-error]').forEach((node) => node.remove());



      root.querySelectorAll('.ir-om-required-invalid').forEach((node) => node.classList.remove('ir-om-required-invalid'));



    }







    function showErrors(errors) {



      clearErrors();



      errors.forEach(({ section, message }) => {



        section.classList.add('ir-om-required-invalid');



        const notice = document.createElement('p');



        notice.className = 'ir-om-required-error';



        notice.setAttribute('data-ir-om-required-error', '');



        notice.setAttribute('role', 'alert');



        notice.textContent = '※ ' + message;



        const heading = section.querySelector('.ir-om__heading');



        if (heading) heading.insertAdjacentElement('afterend', notice);



        else section.prepend(notice);



      });



      errors[0]?.section?.scrollIntoView({ behavior: 'smooth', block: 'center' });



    }







    // CSSをJSから一度だけ追加。既存CSSファイルの編集は不要。



    if (!document.getElementById('ir-om-required-validation-style')) {



      const style = document.createElement('style');



      style.id = 'ir-om-required-validation-style';



      style.textContent = '.ir-om-required-invalid{border-color:#b3261e!important}.ir-om-required-error{margin:0 0 12px!important;color:#b3261e!important;font-size:11px!important;font-weight:600;line-height:1.6}';



      document.head.appendChild(style);



    }







    // 入力が更新されたらエラー表示をクリア。次の購入時に全項目を再検証。



    root.addEventListener('click', (event) => {



      if (event.target.closest('[data-ir-om-size],[data-ir-om-tweed],[data-ir-om-color],[data-ir-om-ratio],[data-ir-om-major-color],[data-ir-om-decoration-toggle],[data-ir-om-decoration]')) clearErrors();



    });



    root.addEventListener('input', (event) => {



      if (event.target.matches('[data-ir-om-count-input]')) clearErrors();



    });







    function blockIfInvalid(event) {



      const errors = validate();



      if (!errors.length) return;



      event.preventDefault();



      event.stopImmediatePropagation();



      event.stopPropagation();



      showErrors(errors);



    }







    // Shopify/DawnのAjax送信より先に検証する（capture）。



    form.addEventListener('submit', blockIfInvalid, true);



    // テーマ独自のクリック送信にも対応。



    form.addEventListener('click', (event) => {



      const button = event.target.closest('button[type="submit"], input[type="submit"]');



      if (button && button.form === form) blockIfInvalid(event);



    }, true);



  });



});





/* =========================================================

   IRiller ORDER MADE / DECORATION AUTO-ADD

   花束と装飾オプションをShopifyの一括追加APIで登録

   ※既存の必須チェック、Variant連動、表示処理は変更しない

\========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[data-ir-order-made]').forEach((root) => {

    const formId = root.dataset.productFormId;

    const form = formId ? document.getElementById(formId) : null;

    if (!form) return;



    let sending = false;

    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';



    function selectedButton(selector) {

      return Array.from(root.querySelectorAll(selector)).find((button) =>

        button.classList.contains('is-selected') || button.getAttribute('aria-pressed') === 'true'

      );

    }



    function getDecorationItems() {

      const mode = selectedButton('[data-ir-om-decoration-toggle]');

      if (!mode || mode.dataset.irOmDecorationToggle !== 'yes') return [];

      const button = selectedButton('[data-ir-om-decoration]');

      if (!button) return [];

      if (button.dataset.decorationType === 'mixed') {

        return [

          { id: Number(button.dataset.crystalVariantId), quantity: Number(button.dataset.crystalQuantity || 1) },

          { id: Number(button.dataset.pearlVariantId), quantity: Number(button.dataset.pearlQuantity || 1) }

        ];

      }

      return [{ id: Number(button.dataset.decorationVariantId), quantity: Number(button.dataset.decorationQuantity || 1) }];

    }



    function showAddError(message) {

      let error = root.querySelector('[data-ir-om-cart-add-error]');

      if (!error) {

        error = document.createElement('p');

        error.setAttribute('data-ir-om-cart-add-error', '');

        error.setAttribute('role', 'alert');

        error.style.cssText = 'margin:12px 0;color:#b3261e;font-size:12px;font-weight:600;line-height:1.7;';

        const submit = form.querySelector('[type="submit"]');

        if (submit && submit.parentElement) submit.parentElement.insertAdjacentElement('beforebegin', error);

        else root.appendChild(error);

      }

      error.textContent = message;

      error.scrollIntoView({ behavior: 'smooth', block: 'center' });

    }



    form.addEventListener('submit', async (event) => {

      // 装飾なしは既存のDawn標準カート追加に任せる。

      
      // 花びら装飾または刺繍がある場合は、一括カート追加を使用
      const mode = selectedButton('[data-ir-om-decoration-toggle]');
      const hasDecoration = mode?.dataset.irOmDecorationToggle === 'yes';

      
      // 刺繍の入力途中・未確定を検出
      const hasUnconfirmedEmbroidery =
        window.IRillerEmbroidery?.hasUnconfirmedInput(root) === true;

      if (hasUnconfirmedEmbroidery) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        alert('刺繍内容が確定されていません。刺繍サービスの内容を確定してください。');

        root.querySelector('[data-ir-embroidery]')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }
      
      const embroideryRoot = root.querySelector('[data-ir-embroidery]');
      const embroideryState = embroideryRoot?.irEmbroideryState;
      const hasEmbroidery = embroideryState?.confirmed === true;

      // 一度でも刺繍を確定した場合、再確定が必要な状態を検出
      const embroideryNeedsConfirmation =
        embroideryState?.hasBeenConfirmed === true && !hasEmbroidery;

      // 刺繍の再確定が必要な場合は、通常のカート追加を止める
      if (embroideryNeedsConfirmation) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        alert('刺繍内容が変更されています。刺繍サービスの内容をもう一度確定してください。');
        embroideryRoot?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!hasDecoration && !hasEmbroidery) return;





      // 既存の必須チェックに委ねる。未入力時は既存の先行リスナーが中断する。

      // 万一、別の送信経路から来ても未選択のまま追加しない。

      const chosen = selectedButton('[data-ir-om-decoration]');

      
      // 装飾ありの場合のみ、装飾の選択を必須にする
      if (hasDecoration && !chosen) return;




      event.preventDefault();

      event.stopImmediatePropagation();

      event.stopPropagation();

      if (sending) return;



      const button = form.querySelector('[type="submit"]');

      const previousDisabled = button ? button.disabled : false;

      const error = root.querySelector('[data-ir-om-cart-add-error]');

      if (error) error.remove();



      try {
        
            // 花びら装飾を選択している場合のみ、装飾商品を取得
            const addons = hasDecoration ? getDecorationItems() : [];

            // 装飾ありの場合のみ、装飾商品の設定を検証
            if (hasDecoration && (
              !addons.length ||
              addons.some((item) =>
                !Number.isSafeInteger(item.id) ||
                item.id <= 0 ||
                !Number.isInteger(item.quantity) ||
                item.quantity < 1
              )
            )) {
              throw new Error('装飾オプションの設定を確認してください。');
            }




        const data = new FormData(form);

        const mainId = Number(data.get('id'));

        const mainQuantity = Number(data.get('quantity') || 1);

        if (!Number.isSafeInteger(mainId) || mainId <= 0 || !Number.isInteger(mainQuantity) || mainQuantity < 1) {

          throw new Error('花束の種類・数量を確認してください。');

        }



        const properties = {};

        for (const [key, value] of data.entries()) {

          const match = key.match(/^properties\[(.+)\]$/);

          if (match && String(value).trim()) properties[match[1]] = String(value);

        }



        sending = true;

        if (button) button.disabled = true;



        // 同時追加する花束と装飾を、一意の注文グループIDで紐づける。
        const bundleId = 'ir-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
        // 刺繍カスタマイザーで確定した刺繍情報を取得
        const embroideryItem = window.IRillerEmbroidery?.getOrderMadeItem(root) || null;
        
            const items = [
              {
                id: mainId,
                quantity: mainQuantity,
                properties: {
                  ...properties,
                  _ir_bundle_id: bundleId,
                  _ir_bundle_role: 'main'
                }
              },
              ...addons.map(item => ({
                id: item.id,
                quantity: item.quantity * mainQuantity,
                properties: {
                  _ir_bundle_id: bundleId,
                  _ir_bundle_role: 'addon',
                  _ir_bundle_per_main: String(item.quantity)
                }
              })),
              ...(embroideryItem ? [{
                id: embroideryItem.id,
                quantity: mainQuantity,
                properties: {
                  ...embroideryItem.properties,
                  ir_bundle_id: bundleId,
                  ir_bundle_role: 'addon',
                  ir_bundle_per_main: '1'
                }
              }] : [])
            ];


        const response = await fetch(rootPath + 'cart/add.js', {

          method: 'POST',

          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

          credentials: 'same-origin',

          body: JSON.stringify({ items })

        });

        const result = await response.json();

        if (!response.ok) throw new Error(result.description || result.message || 'カートへの追加に失敗しました。');



        // 一括追加後はカートページで花束・装飾・数量・金額を確認してもらう。

        window.location.assign(rootPath + 'cart');

      } catch (error) {

        console.error('[IR Order Made] 装飾同時追加エラー:', error);

        showAddError('カートに追加できませんでした。' + (error.message || '時間をおいて再度お試しください。'));

      } finally {

        sending = false;

        if (button) button.disabled = previousDisabled;

      }

    }, true);

  });

});
